<div class="content-wrapper-inner">
    <div class="page-content">
        <div class="mb-20">
            <app-appscripts-user-filter [model]="model" (onSubmit)="onFilter($event)"></app-appscripts-user-filter>
        </div>
        <div class="pos-relative">
            <app-appscripts-user-table (changeBatch)="selectedRows = $event"></app-appscripts-user-table>
            <div class="table-action-info-bar" *ngIf="selectedRows.length">
                <div class="info-left">
                    <div class="text-icon-holder" (click)="batchClear()">
                        <span class="icon">
                            <span class="selected icon-done"></span>
                        </span>
                        <span class="text">{{selectedRows.length}} Selected</span>
                    </div>
                </div>
                <div class="info-right">
                    <div class="text-icon-holder" (click)="onClickCopyPhones()">
                        <span class="icon">
                            <i class="far fa-copy"></i>
                        </span>
                        <span class="text">Copy phones</span>
                    </div>
                    <div class="text-icon-holder" (click)="onBatchDelete()">
                        <span class="icon">
                            <i class="fa fa-trash"></i>
                        </span>
                        <span class="text">Delete</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
